module.exports = __webpack_public_path__ + "media/kuacanghbb.7bb1b139.mp3";